import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BBSPage from "../pages/bbs/page";
import CoursesPage from "../pages/courses/page";
import CourseDetailPage from "../pages/courses/CourseDetail";
import CasesPage from "../pages/cases/page";
import CaseDetailPage from "../pages/cases/CaseDetailPage";
import ExpertDetailPage from "../pages/experts/ExpertDetailPage";
import ColumnPage from "../pages/column/page";
import ArticleDetailPage from "../pages/column/ArticleDetailPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/bbs",
    element: <BBSPage />,
  },
  {
    path: "/courses",
    element: <CoursesPage />,
  },
  {
    path: "/courses/:id",
    element: <CourseDetailPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetailPage />,
  },
  {
    path: "/experts/:id",
    element: <ExpertDetailPage />,
  },
  {
    path: "/column",
    element: <ColumnPage />,
  },
  {
    path: "/column/:id",
    element: <ArticleDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
